import Swiper from 'swiper';
// eslint-disable-next-line import/no-unresolved
import {Navigation} from 'swiper/modules';
import {initCatalogCardImageOrientation} from './catalog-image-orientation';

document.addEventListener('DOMContentLoaded', () => {
    initCatalogCardImageOrientation();
    const sliders = document.querySelectorAll('.viewed-slider');

    if (!sliders.length) return;

    sliders.forEach((slider) => {
        new Swiper(slider, {
            modules: [Navigation],

            wrapperClass: 'viewed__slider',
            slideClass: 'viewed__item',

            navigation: {
                prevEl: slider.querySelector('.viewed__btn--prev'),
                nextEl: slider.querySelector('.viewed__btn--next'),
            },

            breakpoints: {
                0: {
                    slidesPerView: 2,
                    spaceBetween: 12,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
                1200: {
                    slidesPerView: 5,
                    spaceBetween: 20,
                },
            },

            watchOverflow: true,
            loop: false,
        });
    });
});
